/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsListAodRunsQueryResponse, AuditReportsListAodRunsQueryParams, AuditReportsListAodRuns401, AuditReportsListAodRuns403 } from "../models/AuditReportsListAodRuns";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsListAodRuns } from "../axios/auditReportsListAodRuns";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsListAodRunsQueryKey = (params: AuditReportsListAodRunsQueryParams = {}) => ["api-v2", { url: '/audit-reports/v1/aod-runs' }, ...(params ? [params] : [])] as const

export type AuditReportsListAodRunsQueryKey = ReturnType<typeof auditReportsListAodRunsQueryKey>

export function auditReportsListAodRunsQueryOptions(params?: AuditReportsListAodRunsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsListAodRunsQueryKey(params)
        return queryOptions<AuditReportsListAodRunsQueryResponse, ResponseErrorConfig<AuditReportsListAodRuns401 | AuditReportsListAodRuns403>, AuditReportsListAodRunsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsListAodRuns(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve multiple AodRuns
 * {@link /audit-reports/v1/aod-runs}
 */
export function useAuditReportsListAodRuns<TData = AuditReportsListAodRunsQueryResponse, TQueryData = AuditReportsListAodRunsQueryResponse, TQueryKey extends QueryKey = AuditReportsListAodRunsQueryKey>(params?: AuditReportsListAodRunsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsListAodRunsQueryResponse, ResponseErrorConfig<AuditReportsListAodRuns401 | AuditReportsListAodRuns403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsListAodRunsQueryKey(params)
         

         const query = useQuery({
          ...auditReportsListAodRunsQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsListAodRuns401 | AuditReportsListAodRuns403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}